import {
  Box,
  Tooltip,
  Badge,
  tooltipClasses,
  styled,
  useTheme
} from '@mui/material';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LogoSVG } from '../../assets/images/itarra.svg';
import { ThemeContext } from '../../theme/ThemeProvider';



const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        width: 53px;
        margin: 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const LogoSignWrapper = styled(Box)(
  () => `
        width: 52px;
        height: 38px;
`
);

const TooltipWrapper = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100]
  }
}));

const SVGContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSidebarOpen', // this ensures that the isSidebarOpen prop isn't passed to the underlying Box component
})(({ isSidebarOpen }) => ({
  height: '100vh',
  marginLeft: isSidebarOpen ? '21px' : '-21px',
}));


function Logo({isSidebarOpen} ) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { version } = useContext(ThemeContext);

  return (
    <TooltipWrapper
      title={t('MyItarra Platform')}
      arrow
    >
      <LogoWrapper to="/overview">
        <Badge
            sx={{
              '.MuiBadge-badge': {
                fontSize: theme.typography.pxToRem(11),
                right: isSidebarOpen ? '-80px' : '-35px',
                top: 20,
                backgroundColor: theme.colors.alpha.black[5],
                borderColor: 'white',   // <-- Set the border color to white
                borderWidth: '1px',     // <-- Define the border width. Adjust as necessary.
                borderStyle: 'solid',   // <-- Define the border style. Adjust if you want a different style.
        
              }
            }}
            overlap="circular"
            color="success"
            badgeContent = { version }
          >
          <LogoSignWrapper>
            <SVGContainer isSidebarOpen={isSidebarOpen} >
              <LogoSVG style={{ width: '100px', height: '50px', marginTop: '10px' }} /> 
            </SVGContainer>
          </LogoSignWrapper>
        </Badge>
      </LogoWrapper>
    </TooltipWrapper>
  );
}

export default Logo;
